import React from 'react';
import { Container, Button } from 'react-bootstrap';
import MarketingLayout from '../components/layout/MarketingLayout';

const AboutPage = () => (
  <MarketingLayout>
    <section className="marketing-page-header">
      <Container>
        <h1>About Garden Sync</h1>
        <p className="lead">Garden technology rooted in real-world experience.</p>
      </Container>
    </section>

    <section className="marketing-content">
      <Container>
        <div className="marketing-prose">
          <h2>The Founder</h2>
          <p>
            Corbin Lamplot grew up on a farm in northeast Nebraska, where his passion for agriculture and wonder of technology created the first spark for Garden Sync. Having a strong interest in technology led Corbin to the University of Nebraska-Lincoln where he earned his B.S. in Computer Science in 2023. During his time in school, he learned about the endless possibilities that microcontroller technology could provide to everyday people, which inspired him to use his experiences to develop his first auto watering system.
          </p>
          <p>
            The first auto watering system was built in his and his wife&apos;s small apartment in downtown Lincoln while he was attending the University. With minimal experience in electrical and electronics engineering, much of the circuitry would be considered an insult to professional engineers, but it was early on in his Computer Science journey and if it worked, that was good enough at the time. Using supplies from Menards, electrical components ordered from Amazon, an old cat watering fountain pump, and some custom components printed from his 3D printer, the auto watering system was up and running surprisingly well.
          </p>
          <p>
            Having a busy workload and striving to be on the Dean&apos;s list, Corbin could be worry-free about his plants since he knew they were getting the optimal amount of water every day. The system proved to function well as the catnip he grew for his cat thrived beyond expectation.
          </p>

          <h2>Our Mission</h2>
          <p>
            At Garden Sync, our mission is to empower gardeners with the tools they need to nurture their plants with precision and ease. We believe that technology can transform the way we care for our green spaces, making gardening accessible and enjoyable for everyone, from beginners to seasoned experts.
          </p>

          <h2>Join Us</h2>
          <p>
            Whether you&apos;re a tech-savvy gardener or just starting out, Garden Sync is here to help you grow. Join our community to stay informed about updates and the beta testing process. We will be looking for beta testers in the coming months to help us refine the product and ensure it meets the needs of gardeners everywhere.
          </p>

          <div className="text-center mt-4">
            <Button
              href="https://community.gardensync.com/communities/groups/garden-sync-community"
              target="_blank"
              rel="noopener noreferrer"
              variant="secondary"
              size="lg"
            >
              Join Our Community
            </Button>
          </div>
        </div>
      </Container>
    </section>
  </MarketingLayout>
);

export default AboutPage;